// removed by extract-text-webpack-plugin
module.exports = {"container":"wverN"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Channel/style.scss
// module id = LH19
// module chunks = 0